import React, { useEffect, useState } from "react";
import { getAllDocsSnap } from "../../../utils/firebase/Firebase.utils";
import { MdOutlineWarningAmber } from "react-icons/md";
import { IoClose } from "react-icons/io5";

export default function AdvisoryComponent() {
  const [advisory, setAdvisory] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [dismissed, setDismissed] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchAdvisory = async () => {
      await getAllDocsSnap("announcements", (data) => {
        const advisoryItem = data.find(
          (announcement) => announcement.type === "advisory"
        );
        setAdvisory(advisoryItem);
        setIsLoading(false);
      });
    };
    fetchAdvisory();
  }, []);

  if (isLoading) {
    return (
      <div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm px-3 py-3 mt-2 animate-pulse">
        <div className="flex items-center">
          <div className="w-7 h-7 bg-red-100 rounded-full flex items-center justify-center mr-2"></div>
          <div className="flex-1">
            <div className="h-3 bg-gray-200 rounded w-1/3 mb-1"></div>
            <div className="h-2 bg-gray-100 rounded w-3/4"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!advisory || dismissed) {
    return null;
  }

  return (
    <>
      <div className="bg-white rounded-xl shadow-sm mt-2 overflow-hidden">
        <div
          className="px-3 py-3"
          style={{
            background: "linear-gradient(to right, #ffebee, #ffcdd2)",
            borderLeft: "4px solid #f44336",
          }}
        >
          <div className="flex items-start">
            <div className="w-7 h-7 bg-red-500/10 rounded-full flex items-center justify-center mr-2 mt-0.5">
              <MdOutlineWarningAmber className="text-red-500 text-lg" />
            </div>
            <div className="flex-1">
              <div className="flex justify-between items-start">
                <h3 className="text-xs font-semibold text-red-600">
                  {advisory.title}
                </h3>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setDismissed(true);
                  }}
                  className="text-gray-400 hover:text-gray-600 p-1 -mr-1 -mt-1"
                >
                  <IoClose size={14} />
                </button>
              </div>
              <div
                className="text-[11px] text-gray-700 mt-0.5 leading-snug cursor-pointer"
                onClick={() => setShowModal(true)}
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 4,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {advisory.Details}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50"
          onClick={() => setShowModal(false)}
        >
          <div
            className="bg-white rounded-xl shadow-lg max-w-md w-full max-h-[80vh] overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="px-4 py-4 border-b border-gray-100">
              <div className="flex justify-between items-center">
                <div className="flex items-center">
                  <MdOutlineWarningAmber className="text-red-500 mr-2" />
                  <h3 className="font-semibold text-gray-800">
                    {advisory.title}
                  </h3>
                </div>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-400 hover:text-gray-600 p-1"
                >
                  <IoClose size={18} />
                </button>
              </div>
            </div>
            <div className="px-4 py-4">
              <p className="text-sm text-gray-700 whitespace-pre-line">
                {advisory.Details}
              </p>
            </div>
            <div className="px-4 py-3 bg-gray-50 rounded-b-xl">
              <button
                onClick={() => setShowModal(false)}
                className="w-full py-2 bg-[#363062] text-white rounded-lg text-xs font-medium"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
